var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"col-12 col-lg-8 px-0 px-sm-3 pr-xl-0"},[_c('CreateMindo',{attrs:{"questionId":_vm.questionId,"questionName":_vm.questionName}}),_c('MindoTabs',{attrs:{"questionId":_vm.questionId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }